import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import {
	Grid,
	Button,
	ExpansionPanel,
	ExpansionPanelSummary,
	ExpansionPanelDetails,
	withStyles,
} from '@material-ui/core'
import { ExpandMore, ExpandLess } from '@material-ui/icons'
import styles from 'components/AddOrEditTaskPage/styles'
import { toggleBottomMenu } from 'actions/contacts/addOrEdit'
import classNames from 'classnames'
import BottomMenu from './BottomMenu'

export default connect(
	(state) => ({ bottomMenuOpen: state.contacts.bottomMenuOpen }),
	(dispatch) => bindActionCreators({ toggleBottomMenu }, dispatch),
)(
	withStyles(styles)(
		({ classes, toggleBottomMenu, bottomMenuOpen, mobile }) => {
			return (
				<ExpansionPanel
					className={
						mobile
							? classes.expansionPanelMobile
							: classNames(
									classes.expansionPanel,
									classes.expansionPanelNoMargin,
							  )
					}
					classes={{ expanded: classes.panelExpanded }}
					style={{ left: 0, bottom: 56, zIndex: 5 }}
					expanded={bottomMenuOpen}
					onChange={toggleBottomMenu}
				>
					<ExpansionPanelSummary
						classes={{
							root: classes.panelSummary,
						}}
					>
						<Grid
							container
							alignItems="center"
							justify="space-between"
							style={{ padding: 0 }}
						>
							<Grid item>
								<Button>
									{bottomMenuOpen ? <ExpandMore /> : <ExpandLess />}
									Contact Details
								</Button>
							</Grid>
						</Grid>
					</ExpansionPanelSummary>
					<ExpansionPanelDetails
						classes={
							mobile ? { root: classes.panelDetailsRootMobileContacts } : null
						}
						style={{
							maxHeight: '48vh',
							overflowY: 'auto',
							overflowX: 'hidden',
						}}
					>
						<BottomMenu />
					</ExpansionPanelDetails>
				</ExpansionPanel>
			)
		},
	),
)
